import React, { useState } from "react";
import { Mail, Phone, MessageCircle, ChevronUp } from "lucide-react";
import maa from "../../Assets/Logos/maabhairabi.png";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
const Footer = () => {
  const [email, setEmail] = useState("");
   const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const handleSubscribe = (e) => {
    e.preventDefault();
    console.log("Subscribing email:", email);
    // Add subscription logic here
    setEmail("");
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  
  const footerLinks = {
    

    pages: [
      { name: "Home", path: "/" },
      { name: "About us", path: "/about" },
      { name: "Cab Packages", path: "/car" },
      { name: "Tour Pcakages", path: "/tour" },
      { name: "Contact us", path: "/contact" },
    ],
    cab: [
      { name: "Sedan" },
      { name: "Suv" },
      { name: "Crossover" },
      { name: "Tempo-Traveller" },
      { name: "more...", path: "/car" },
    ],
    odisha: [
      { name: "Simlipal" },
      { name: "Bhubaneswar" },
      { name: "Chilika" },
      { name: "Puri" },
      { name: "more...", path: "/tour" },
    ],
    Tours: [
      { name: "Darjelling" },
      { name: "Goa" },
      { name: "Jaipur" },
      { name: "kerala" },
      { name: "more...", path: "/tour" },
     
    ],
  };

  const socialLinks = [
    { icon: "facebook", href: "#", label: "Facebook" },
    { icon: "instagram", href: "#", label: "Instagram" },
    { icon: "youtube", href: "#", label: "Youtube" },
    { icon: "whatsapp", href: "#", label: "Whatsapp" },
    
  ];

  const bottomLinks = [
    { name: "Legal Notice", href: "#" },
    { name: "Privacy Policy", href: "#" },
    { name: "Terms and Conditions", href: "#" },
    { name: "Refund Policy", href: "#" },
    { name: "Chat Support", href: "#" },
  ];

  const renderSocialIcon = (icon) => {
    const iconClass = "w-5 h-5";
    switch (icon) {
      case "facebook":
        return (
          <svg className={iconClass} fill="currentColor" viewBox="0 0 24 24">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
        );
      // case "twitter":
      //   return (
      //     <svg className={iconClass} fill="currentColor" viewBox="0 0 24 24">
      //       <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
      //     </svg>
      //   );
      case "instagram":
        return (
          <svg className={iconClass} fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
          </svg>
        );
      // case "linkedin":
      //   return (
      //     <svg className={iconClass} fill="currentColor" viewBox="0 0 24 24">
      //       <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      //     </svg>
      //   );
      case "youtube":
  return (
    <svg className={iconClass} fill="currentColor" viewBox="0 0 24 24">
      <path d="M23.498 6.186a2.998 2.998 0 00-2.112-2.12C19.504 3.5 12 3.5 12 3.5s-7.504 0-9.386.566a2.998 2.998 0 00-2.112 2.12A31.2 31.2 0 000 12a31.2 31.2 0 00.502 5.814 2.998 2.998 0 002.112 2.12C4.496 20.5 12 20.5 12 20.5s7.504 0 9.386-.566a2.998 2.998 0 002.112-2.12A31.2 31.2 0 0024 12a31.2 31.2 0 00-.502-5.814zM9.75 15.02V8.98L15.5 12l-5.75 3.02z" />
    </svg>
  );
  case "whatsapp":
  return (
    <svg className={iconClass} fill="currentColor" viewBox="0 0 24 24">
      <path d="M20.52 3.48A11.78 11.78 0 0012.01 0C5.37 0 .02 5.35.02 12c0 2.12.55 4.18 1.6 6L0 24l6.2-1.62A11.9 11.9 0 0012 24c6.63 0 12-5.35 12-12 0-3.19-1.24-6.19-3.48-8.52zM12 21.82c-1.85 0-3.66-.5-5.25-1.45l-.38-.23-3.68.96.98-3.59-.25-.37a9.77 9.77 0 01-1.5-5.24C2.92 6.48 7.4 2 12 2c2.61 0 5.07 1.02 6.92 2.87A9.74 9.74 0 0121.82 12c0 5.4-4.4 9.82-9.82 9.82zm5.38-7.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.28-.47-2.43-1.5-.9-.8-1.5-1.8-1.68-2.1-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.05 1.02-1.05 2.5s1.08 2.9 1.23 3.1c.15.2 2.12 3.23 5.13 4.53.72.31 1.28.5 1.72.64.72.23 1.37.2 1.88.12.57-.08 1.76-.72 2.01-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z" />
    </svg>
  );
      default:
        return null;
    }
  };

  return (
    <footer className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
      {/* Main Footer Content */}
      <div className="relative z-10 w-full mx-auto px-4 sm:px-6 lg:px-20 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-12">
          {/* Brand Section - Takes 4 columns */}
          <div className="lg:col-span-4">
            {/* Logo */}
            <div className="flex items-center gap-2 pb-3 -ml-4">
              {/* Logo Icon */}
              <div className="flex justify-items-center">
                <img src={maa} alt="" className="w-44 h-auto" />
              </div>
            </div>

            {/* Mission Statement */}
            <p className="text-gray-400 md:text-[16px] leading-relaxed mb-6">
              Our mission is to offer you a seamless and enjoyable car rental
              experience. Whether you're planning a road trip
            </p>

            {/* Newsletter */}
            <div className="mb-4">
              {/* <h3 className="text-white font-semibold md:text-xl mb-2">
                Subscribe to Our Newsletter
              </h3>
              <p className="text-gray-400 text-[16px">
                Just sign up and we'll send you a notification by email.
              </p> */}

              {/* Email Input */}
              {/* <form onSubmit={handleSubscribe} className="relative">
                <div className="flex items-center bg-white rounded-full overflow-hidden shadow-lg">
                  <div className="pl-4 pr-2">
                    <Mail className="w-5 h-5 text-gray-400" />
                  </div>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter Email Address"
                    className="flex-1 py-3 px-2 text-gray-900 text-sm focus:outline-none"
                    required
                  />
                  <button
                    type="submit"
                    className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 py-3 font-semibold text-sm hover:from-orange-600 hover:to-red-700 transition-all duration-300"
                  >
                    Subscribe
                  </button>
                </div>
              </form> */}
            </div>

            {/* Social Links */}
            <div className="flex items-center space-x-3">
              {socialLinks.map((social) => (
                <a
                  key={social.icon}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white hover:bg-gradient-to-r hover:from-orange-500 hover:to-red-600 transition-all duration-300 hover:scale-110"
                >
                  {renderSocialIcon(social.icon)}
                </a>
              ))}
            </div>
          </div>

          {/* Pages Links - Takes 2 columns */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-semibold text-lg mb-4">Links</h3>
            <ul className="space-y-2">
              {footerLinks.pages.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => navigate(link.path)}
                    className="text-gray-400 text-[14px] hover:text-orange-500 transition-colors duration-300 hover:translate-x-1 inline-block"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links - Takes 3 columns */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-semibold text-lg mb-4">Cabs</h3>
            <ul className="space-y-2">
              {footerLinks.cab.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => navigate(link.path)}
                    className="text-gray-400 text-[14px] hover:text-orange-500 transition-colors duration-300 hover:translate-x-1 inline-block"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Destinations Links - Takes 3 columns */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-semibold text-lg mb-4">
              Odisha Tours
            </h3>
            <ul className="space-y-2">
              {footerLinks.odisha.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => navigate(link.path)}
                    className="text-gray-400 text-[14px] hover:text-orange-500 transition-colors duration-300 hover:translate-x-1 inline-block"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="text-white font-semibold text-lg mb-4">
              Domestic Tours
            </h3>
            <ul className="space-y-2">
              {footerLinks.Tours.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => navigate(link.path)}
                    className="text-gray-400 text-[14px] hover:text-orange-500 transition-colors duration-300 hover:translate-x-1 inline-block"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Information */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full mt-8 pt-8 border-t border-gray-700 ">
          {/* Customer Support */}
          <div className="flex items-center space-x-4 ">
            <div className="w-12 h-12 bg-gradient-to-r from-red-500 to-orange-600 rounded-full flex items-center justify-center flex-shrink-0">
              <Phone className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-gray-400 text-sm mb-1">Customer Support</p>
              <a
                href="tel:+15658954598"
                className="text-white font-semibold hover:text-orange-500 transition-colors"
              >
                +91 78946 75466
              </a>
            </div>
          </div>

          {/* Drop Us an Email */}
          <div className="flex items-center space-x-4 ">
            <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
              <Mail className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-gray-400 text-sm mb-1">Drop Us an Email</p>
              <a
                href="mailto:info@example.com"
                className="text-white font-semibold hover:text-orange-500 transition-colors"
              >
                info@example.com
              </a>
            </div>
          </div>

          {/* Toll Free */}
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
              <MessageCircle className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-gray-400 text-sm mb-1">Toll Free</p>
              <a
                href="tel:+15656954698"
                className="text-white font-semibold hover:text-orange-500 transition-colors"
              >
                +91 77351 72177
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="mt-8 pt-8 border-t border-gray-700">
         <div className="flex flex-wrap justify-between items-center w-full py-2 px-6 text-sm  text-white">
          <div className="flex ">
                  <span className="mr-2">© {currentYear},</span>
         <span className="font-semibold text-red-600">Maa Bhairabhi</span>
         <span className="ml-2">All Rights Reserved.</span>
          </div>        
     
         <button onClick={() => navigate("https://maa-bhairabi-sgep.vercel.app/auth/sign-in")} className="px-3 py-2 bg-red-600 text-white hover:bg-white hover:text-red-600 border border-red-600 transition-all duration-300 rounded-md">Admin Login</button>
          <span
          onClick={() => window.open("https://webbocket.com/", "_blank")}
          className="text-white underline cursor-pointer hover:text-gray-200"
        >
          Developed by Web_Bocket PVT LTD.
        </span>
      </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
        <button
        onClick={() => window.open("https://www.whatsapp.com", "_blank")}
        className="fixed bottom-24 right-8 w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-full shadow-xl flex items-center justify-center hover:scale-110 transition-transform duration-300 z-50 group"
        aria-label="Scroll to top"
      >
        <FaWhatsapp className="w-6 h-6 group-hover:animate-pulse" />
      </button>

      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-full shadow-xl flex items-center justify-center hover:scale-110 transition-transform duration-300 z-50 group"
        aria-label="Scroll to top"
      >
        <ChevronUp className="w-6 h-6 group-hover:animate-bounce" />
      </button>
    </footer>
  );
};

export default Footer;
